import {$} from '../jquery-definition.js';

$( function() {
	$( 'form' ).on( 'click', function( clickEvent ) {
		var $this = $( this );

		$this.find( '.g-recaptcha' ).addClass( 'active' );
	} );

	$( '.wpcf7-select' ).parents( 'label' ).addClass( 'select' );

	$( '[name="your-physical-report"]' ).on( 'change', function( clickEvent ) {
		$( '.wpcf7' ).find( '.address-container' ).stop().slideToggle( 100 );

		if ( $( this ).is( ':checked' ) ) {
			$( '.wpcf7' ).find( '.address-container input' ).val( '' );
		} else {
			setTimeout( () => {
				$( '.wpcf7' ).find( '.address-container input' ).val( 'N/A' );
			}, 100 );
		}
	} );

	$( '.wpcf7' ).find( '.address-container input' ).val( 'N/A' );
} );
